var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 1.83057C0.40625 1.11279 0.980469 0.518066 1.71875 0.518066H8.28125C8.99902 0.518066 9.59375 1.11279 9.59375 1.83057V8.39307C9.59375 9.13135 8.99902 9.70557 8.28125 9.70557H1.71875C0.980469 9.70557 0.40625 9.13135 0.40625 8.39307V1.83057ZM1.8418 2.979C1.65723 3.18408 1.67773 3.4917 1.8623 3.67627L3.44141 5.11182L1.8623 6.56787C1.67773 6.75244 1.65723 7.06006 1.8418 7.26514C2.02637 7.44971 2.33398 7.47021 2.53906 7.28564L4.50781 5.48096C4.61035 5.39893 4.67188 5.25537 4.67188 5.11182C4.67188 4.98877 4.61035 4.84521 4.50781 4.76318L2.53906 2.9585C2.33398 2.77393 2.02637 2.77393 1.8418 2.979ZM4.83594 6.75244C4.54883 6.75244 4.34375 6.97803 4.34375 7.24463C4.34375 7.53174 4.54883 7.73682 4.83594 7.73682H7.78906C8.05566 7.73682 8.28125 7.53174 8.28125 7.24463C8.28125 6.97803 8.05566 6.75244 7.78906 6.75244H4.83594Z",
    fill: "#99A5A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.f239a903a89c8f813bca9e95da086d52.svg";
export { ForwardRef as ReactComponent };